import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-audience-root',
    templateUrl: './audience-root.component.html',
    styleUrls: ['./audience-root.component.scss'],
})
export class AudienceRootComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
